import { defineStore } from "pinia";
import vhCheck from "vh-check";

const MobileSize = 540;
const TabletSize = 1100;
const Tablet2Size = 780;

interface NavigationItem {
  link?: any;
  name?: string;
  section?: string;
  isBroken?: boolean;
}

interface DocumentScreenSize {
  width: number;
  height: number;
  isTablet: boolean;
  isTablet2: boolean;
  isMobile: boolean;
  isDesktop: boolean | null;
  scrollBarWidth: number;
}

interface LayoutState {
  navigation: NavigationItem[];
  documentScreenSize: DocumentScreenSize;
  headerHidden: boolean;
  showModalName: string | null;
  changeHeroStepNow: boolean;
}

function getScrollbarWidth() {
  const scrollDiv = document.createElement("div");
  scrollDiv.style.width = "100px";
  scrollDiv.style.height = "100px";
  scrollDiv.style.overflow = "scroll";
  scrollDiv.style.position = "absolute";
  scrollDiv.style.top = "-9999px";
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

export const useLayoutStore = defineStore("layoutStore", {
  state: (): LayoutState => ({
    navigation: [],
    documentScreenSize: {
      width: 0,
      height: 0,
      isTablet: true,
      isTablet2: true,
      isMobile: true,
      isDesktop: null,
      scrollBarWidth: 0,
    },
    headerHidden: false,
    showModalName: null,
    changeHeroStepNow: false,
  }),
  getters: {
    GET_Navigation: (state) =>
      state.navigation.filter((item) => !item.isBroken),
    GET_DocumentScreenSize: (state) => state.documentScreenSize,
    IS_Tablet: (state) => state.documentScreenSize.isTablet,
    IS_Tablet2: (state) => state.documentScreenSize.isTablet2,
    IS_Mobile: (state) => state.documentScreenSize.isMobile,
    IS_HeaderHidden: (state) => state.headerHidden,
    GET_ShowModal: (state) => state.showModalName,
    IS_ChangeHeroStepNow: (state) => state.changeHeroStepNow,
  },
  actions: {
    SET_Navigation(navData: NavigationItem[]) {
      this.navigation = navData;
    },
    SET_HeaderHidden(value: boolean) {
      this.headerHidden = value;
    },
    setDocScreenSize() {
      try {
        this.documentScreenSize.width = document.documentElement.offsetWidth;
        this.documentScreenSize.height = document.documentElement.clientHeight;
        this.documentScreenSize.isTablet =
          document.documentElement.offsetWidth <= TabletSize;
        this.documentScreenSize.isTablet2 =
          document.documentElement.offsetWidth <= Tablet2Size;
        this.documentScreenSize.isMobile =
          document.documentElement.offsetWidth <= MobileSize;
        this.documentScreenSize.isDesktop =
          !this.documentScreenSize.isTablet &&
          !this.documentScreenSize.isMobile;
        //

        this.documentScreenSize.scrollBarWidth = getScrollbarWidth();

        const root = document.documentElement;

        // let deltaVH =
        //   vhCheck().vh - vhCheck().windowHeight
        //     ? vhCheck().vh - vhCheck().windowHeight
        //     : this.documentScreenSize.isTablet
        //       ? 83
        //       : 0;
        let deltaVH = vhCheck().vh - vhCheck().windowHeight;
        if (this.documentScreenSize.isTablet && deltaVH < 83) deltaVH = 83;
        window.deltaVH = deltaVH;
        root.style.setProperty("--deltaVH", deltaVH + "px");
        root.style.setProperty("--vh", vhCheck().vh + "px");
        root.style.setProperty("--windowHeight", vhCheck().vh - deltaVH + "px");
        document.documentElement.style.setProperty(
          "--scrollPageBarWidth",
          `${this.documentScreenSize.scrollBarWidth}px`
        );
      } catch (e) {
        console.log(e);
      }
    },
    SHOW_Modal(value: string | null) {
      this.showModalName = value;
    },
    HIDE_Modal() {
      this.showModalName = null;
    },
    SET_ChangeHeroStepNow(value: boolean) {
      this.changeHeroStepNow = value;
      document.body.classList.toggle("changeHeroStepNow", value);
    },
  },
});
